import React, { useState } from 'react';
import { Dialog, ElevatedButton, TextButton, TextInput } from '@producer/ui-kit';

import { createTeam } from '../../features/teams/stores/team.slice';
import { Project } from '../../app/entities';

type CreateTeamModalProps = {
  project: Project;
  onCancel: () => void;
};

export const CreateTeamModal: React.FC<CreateTeamModalProps> = ({ project, onCancel }) => {
  const [inputValue, setInputValue] = useState('');

  const handleSubmit = async () => {
    await createTeam({ projectId: project._id, name: inputValue });
    onCancel();
  };

  return (
    <Dialog
      title={'Add team'}
      onCancel={onCancel}
      actions={[
        <TextButton key="cancel" text="Cancel" onClick={onCancel} />,
        <ElevatedButton
          key="add"
          text={'Add'}
          onClick={handleSubmit}
          disabled={inputValue.length <= 2}
        />,
      ]}
    >
      <TextInput
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        label={'Team name'}
        placeholder={'Enter...'}
        name={'name'}
        required
      />
    </Dialog>
  );
};
